module.exports = __webpack_public_path__ + "static/media/Elgyem_gaussian2.b5843455.png";